<template lang="pug">
  .layout
    y-dialog(v-model="showModal" persistent max-width="320")
      v-card
        v-card-title
          div.h6.text-wrapper {{ $t('title') }}
        v-card-text.px-6.pt-2.p2.primary500--text
          div.mb-3 {{ $t('subtitle') }}
          ol
            li {{ $t('reasons.1.main') }}
            ul
              li {{ $t('reasons.1.content.1') }}
              li {{ $t('reasons.1.content.2') }}
            li {{ $t('reasons.2.main') }}
              div.danger400--text {{ $t('reasons.2.content') }}
        v-card-actions.pb-4.px-4
          v-spacer
          v-btn.button-AA-tiny.info500.basic100--text(small depressed @click="showModal = false") Got it
</template>

<script>
export default {
  name: 'OngoingFailedReason',
  props: {
    open: {
      type: Boolean
    }
  },
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(val) {
        this.$emit('update:open', val)
      }
    }
  }
}
</script>

<style scoped>
ul li {
  list-style-type: disc;
}
</style>

<i18n>
{
  "en": {
    "title": "Why is my arrangement unsuccessful?",
    "subtitle": "Failure to arrange delivery could be due to one of the following reasons: ",
    "reasons": {
      "1": {
        "main": "We couldn’t find you a rider. Click retry to try again. This may be due to: ",
        "content": {
          "1": "No available riders in your area",
          "2": "All riders are currently busy"
        }
      },
      "2": {
        "main": "A technical error has occured.",
        "content": "Please rectify the issue before you try to arrange again*."
      }
    }
  },
  "id": {
    "title": "Mengapa pengaturan saya tidak berhasil?",
    "subtitle": "Kegagalan mengatur pengiriman dapat disebabkan oleh salah satu alasan berikut: ",
    "reasons": {
      "1": {
        "main": "Kami tidak dapat menemukan rider untuk kamu. Klik coba lagi untuk mencoba lagi. Ini mungkin karena: ",
        "content": {
          "1": "Tidak ada rider yang tersedia di wilayah kamu",
          "2": "Semua rider sedang sibuk"
        }
      },
      "2": {
        "main": "Terjadi kesalahan teknis.",
        "content": "Harap perbaiki masalah sebelum kamu mencoba mengatur lagi*."
      }
    }
  }
}
</i18n>